var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M17.7145 8.6792C17.7145 8.6792 17.2167 14.8529 16.928 17.4535C16.7905 18.6956 16.0232 19.4234 14.7665 19.4464C12.3749 19.4894 9.98055 19.4922 7.58989 19.4418C6.3808 19.417 5.62639 18.68 5.49164 17.4599C5.20105 14.8364 4.70605 8.6792 4.70605 8.6792",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M18.9823 5.71981H3.4375",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M15.987 5.71973C15.2675 5.71973 14.6478 5.21098 14.5066 4.50607L14.2839 3.3914C14.1464 2.87715 13.6807 2.52148 13.15 2.52148H9.2697C8.73895 2.52148 8.27328 2.87715 8.13578 3.3914L7.91303 4.50607C7.77187 5.21098 7.1522 5.71973 6.43262 5.71973",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdDelete);
export default __webpack_public_path__ + "static/media/ord_delete.ae07b5a277a3c1ddd6464732c3c69f06.svg";
export { ForwardRef as ReactComponent };